import { email } from 'vee-validate/dist/rules';
import i18n from '@/langs/i18n.js';

export default function addVeeValidateRules (VeeValidateExtend) {
  VeeValidateExtend('required', {
    validate: value => value !== null && String(value).trim() !== '',
    computesRequired: true,
    message: () => i18n.t('validation.required')
  });

  VeeValidateExtend('email', {
    ...email,
    message: () => i18n.t('validation.email')
  });

  VeeValidateExtend('valid-url', {
    validate: value => {
      if (value.trim() === '') {
        return true;
      }

      let urlPattern = new RegExp('^(https?:\\/\\/)?((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|((\\d{1,3}\\.){3}\\d{1,3}))(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*(\\?[;&a-z\\d%_.~+=-]*)?(\\#[-a-z\\d_]*)?$', 'i');
      return !!urlPattern.test(value);
    },
    computesRequired: true,
    message: () => i18n.t('validation.url')
  })

  VeeValidateExtend('only-numbers', {
    validate: value => value === value.replace(/[^0-9.]/gm, '') && !Number.isNaN(parseFloat(value.replace(/[^0-9.]/gm, ''))),
    computesRequired: true,
    message: () => i18n.t('validation.onlyNumbers')
  });

  VeeValidateExtend('min', {
    params: ['min'],
    validate: (value, { min }) => value.length >= min,
    message: (field, params) => i18n.tc('validation.minCharacters', params.min)
  });

  VeeValidateExtend('max', {
    params: ['max'],
    validate: (value, { max }) => value.length <= max,
    message: (field, params) => i18n.tc('validation.maxCharacters', params.max)
  });

  VeeValidateExtend('min_value', {
    params: ['minValue'],
    validate: (value, { minValue }) => parseFloat(value) >= parseFloat(minValue),
    message: (field, params) => i18n.tc('validation.minValue', params.minValue)
  });

  VeeValidateExtend('max_value', {
    params: ['maxValue'],
    validate: (value, { maxValue }) => parseFloat(value) <= parseFloat(maxValue),
    message: (field, params) => i18n.tc('validation.maxValue', params.maxValue)
  });

  VeeValidateExtend('password', {
    params: [{
      name: 'original',
      isTarget: true
    }],
    validate: (value, { original }) => value === original,
    message: () => i18n.t('validation.passwordsDontMatch')
  });

  VeeValidateExtend('requiredDateRange', {
    validate: value => !!value && !!value.startDate && !!value.endDate,
    computesRequired: true,
    message: () => i18n.t('validation.dateRange')
  });

  VeeValidateExtend('requiredStartRange', {
    validate: value => !!value && !!value.startDate,
    computesRequired: true,
    message: () => i18n.t('validation.date')
  });

  VeeValidateExtend('postal-code', {
    params: ['postal-code'],
    validate: value => value.match(/(^[0-9]{2}-[0-9]{3}$)/),
    message: () => i18n.t('validation.zipCode')
  });

  VeeValidateExtend('postal-code-gb', {
    params: ['postal-code-gb'],
    validate: value => value.match(/(^(([A-Z]{1,2}[0-9][A-Z0-9]?|ASCN|STHL|TDCU|BBND|[BFS]IQQ|PCRN|TKCA) ?[0-9][A-Z]{2}|BFPO ?[0-9]{1,4}|(KY[0-9]|MSR|VG|AI)[ -]?[0-9]{4}|[A-Z]{2} ?[0-9]{2}|GE ?CX|GIR ?0A{2}|SAN ?TA1)$)/),
    message: () => i18n.t('validation.zipCodeGB')
  });

  VeeValidateExtend('is-checked', {
    params: ['is-checked'],
    validate: value => value === 1 || value === true,
    message: () => i18n.t('validation.isChecked')
  });

  VeeValidateExtend('tel', {
    params: ['tel'],
    validate: value => value.match(/(^(\+?)[0-9\s]*$)/),
    message: () => i18n.t('validation.phone')
  });

  VeeValidateExtend('tin', {
    validate: value => {
      if (value.trim() === '') {
        return true;
      }

      let ninPattern = new RegExp(/(^[A-CEGHJ-PR-TW-Z]{1}[A-CEGHJ-NPR-TW-Z]{1}(\s*)([0-9]{2}(\s*)){3}[A-D]{0,1}$)/, 'i');
      return !!ninPattern.test(value);
    },
    computesRequired: true,
    message: () => i18n.t('validation.tin')
  })
};
